import { CaretRightIcon } from "@phosphor-icons/react";

const FeedbackCard = ({ onClick }) => {
  return (
    <div className="card r4-3 flex col space pointer" onClick={onClick}>
      <div className="flex row space">
        <div>
          <p className="large">Feedback</p>
          {/* <p className="medium o60">Votes remaining</p> */}
        </div>
        <p className="large"><CaretRightIcon /></p>
      </div>
    </div>
  );
};

export default FeedbackCard;
